import { FC, useEffect, useState } from 'react';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import { pageKey } from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { useToggle } from '../../../../hooks/use-toggle';
import { TableFilter } from '../table-filter';
import s from './table-filter-range.module.css';
import { Input } from '../../../../components/input/input';

interface Props {
  name: string;
  checkboxLabel?: string;
}

export const TableFilterRange: FC<Props> = (props) => {
  const { name, checkboxLabel } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const params = getQueryParams();
  const { t } = useLang();
  const [checked, toggleChecked, setChecked] = useToggle(!!params[`${name}-check`]);

  const range = params[name];

  useEffect(() => {
    if (!range) return;
    const asObj = JSON.parse(range);
    setFrom(asObj.from);
    setTo(asObj.to);
  }, [range]);

  const handleOk = () => {
    const rangeParams =
      from || to ? JSON.stringify({ from: from || undefined, to: to || undefined }) : undefined;
    const resultParams = { [name]: rangeParams, [pageKey]: '1' };
    if (checkboxLabel) {
      const checkedParams = checked ? JSON.stringify({ checked }) : undefined;
      resultParams[`${name}-check`] = checkedParams;
    }

    addQueryParams(resultParams);
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1', [`${name}-check`]: undefined });
    setFrom('');
    setTo('');
    setChecked(false);
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      <div className={s.range}>
        <Input
          value={from}
          onChange={(e) => setFrom(e.currentTarget.value)}
          placeholder={t('От')}
          type="number"
        />
        <Input
          value={to}
          onChange={(e) => setTo(e.currentTarget.value)}
          placeholder={t('До')}
          type="number"
        />
      </div>
      {checkboxLabel && (
        <Checkbox
          name={`${name}-check`}
          checked={checked}
          onClick={toggleChecked}
          label={checkboxLabel}
        />
      )}
    </TableFilter>
  );
};
